export default __webpack_public_path__ + "static/content2-531a1096a24d3d53e3a4455b6db1b217.png";